export type Status = 'init' | 'loading' | 'error' | 'afterInput' | 'afterOutput' | 'done';
export type Level = 'stepZero' | 'stepOne' | 'stepTwo' | 'stepThree' | 'stepFour' | 'stepFive' | 'addPhase';

export interface store {
    stepZero: prompt;
    stepOne: prompt;
    stepTwo: prompt;
    stepThree: prompt;
    stepFour: prompt;
    stepFive: prompt;
    addPhase: prompt;
}

export interface prompt {
    response?: Array<string>;
    prompt?: string;
    feedback?: any;
    status: Status;
    display?: boolean;
}

export interface options {
    level: Level;
    status?: Status;
    response?: any;
    prompt?: string;
    feedback?: string[];
    display?: boolean;
}

export interface summary {
    name: string;
    id: number;
    time: string;
    details: string;
}

// JSON interfaces

export interface Phase {
    phaseTitle: string;
    phaseTime: string;
    phaseDescription: string;
}

export interface Phases {
    phases: Phase[];
}

export const presets = {
    "strict": {
        "max_output_tokens": 1024,
        "temperature": 0,
        "top_p": 0.1,
        "top_k": 10
    },
    "semi-strict": {
        "max_output_tokens": 1024,
        "temperature": 0.3,
        "top_p": 0.3,
        "top_k": 30
    },
    "not-strictly-strict": {
        "max_output_tokens": 1024,
        "temperature": 0.5,
        "top_p": 0.6,
        "top_k": 35
    },
    "relaxed": {
        "max_output_tokens": 1024,
        "temperature": 0.7,
        "top_p": 0.95,
        "top_k": 40
    },
    "crazy": {
        "max_output_tokens": 1024,
        "temperature": 1,
        "top_p": 1,
        "top_k": 40
    },
}

